import { Text } from '@quintoandar-tokko/jopijs';
import { useContrastTextColor } from '@/components/shared/Hooks';
import styles from './components.module.scss';

export default function LeadStatusBadge({ text, backgroundColor }) {
  const { textColor } = useContrastTextColor(`${backgroundColor || '#ffffff'}`);
  const safetyBackgroundColor = !backgroundColor
    ? 'transparent'
    : `${backgroundColor}`;

  return (
    <Text
      className={styles.leadStatusBadge}
      style={{ backgroundColor: safetyBackgroundColor, color: textColor }}
    >
      {text}
    </Text>
  );
}
